import 'angular';
import 'angular-animate';
import 'angular-messages';
import 'angular-ui-router';
import 'angular-sanitize';
import 'angular-modal-service';
import 'babel-polyfill';
import 'ng-mask';

export const vendor = [
  'ngAnimate',
  'ngSanitize',
  'ngMessages',
  'ui.router',
  'angularModalService',
  'ngMask',
];



// WEBPACK FOOTER //
// ./frontend/storefront/app/vendor.js